import { types } from '../types'

const initialState = {

    WaitingGetInstruction: false,
    SuccessGetInstruction: false,
    ErrorGetInstruction: '',
    Instruction: {},
    //****************************** */
    WaitingCustomerNumber2: false,
    SuccessCustomerNumber2: false,
    ErrorCustomerNumber2: '',
    Customer: [],
    //***************************** */
    WaitingSaveInstruction: false,
    SuccessSaveInstruction: false,
    ErrorSaveInstruction: '',
    statusSave: false,
    Errors: [],
    //**************************** */
    WaitingCustomMember: false,
    SuccessCustomMember: false,
    ErrorCustomMember: '',
    CustomMember: [],
    //*************************** */




}



const secreteryReducer = (state = initialState, { type, action, error }) => {
    switch (type) {

        case types.GET_INSTRUCTION_REQUEST: {
            return {
                ...state,
                WaitingGetInstruction: true,
                SuccessGetInstruction: false,
            }
        }
        case types.GET_INSTRUCTION_ERROR: {
            return {
                ...state,
                WaitingGetInstruction: false,
                ErrorGetInstruction: "error",
            }
        }
        case types.GET_INSTRUCTION_SUCCESS: {

            return {
                ...state,
                WaitingGetInstruction: false,
                SuccessGetInstruction: true,
                Instruction: action.data

            }
        }
        case types.GET_INSTRUCTION_RESET_PROPS: {
            return {
                ...state,
                WaitingGetInstruction: false,
                SuccessGetInstruction: false,
                ErrorGetInstruction: '',
            }
        }
        //************************************************************************************************ */
        case types.GET_CUSTOMER_MEMBER2_REQUEST: {
            return {
                ...state,
                WaitingCustomerNumber2: true,
                SuccessCustomerNumber2: false,
                Customer: null
            }
        }
        case types.GET_CUSTOMER_NUMBER2_ERROR: {
            return {
                ...state,
                WaitingCustomerNumber2: false,
                ErrorCustomerNumber2: "error",
            }
        }
        case types.GET_CUSTOMER_NUMBER2_SUCCESS: {
            return {
                ...state,
                WaitingCustomerNumber2: false,
                SuccessCustomerNumber2: true,
                Customer: action.data
            }
        }
        case types.GET_CUSTOMER_NUMBER2_RESET_PROPS: {
            return {
                ...state,
                WaitingCustomerNumber2: false,
                SuccessCustomerNumber2: false,
                ErrorCustomerNumber2: '',
            }
        }
        //*************************************************************************************************** */
        case types.SAVE_INSTRUCTION_REQUEST: {
            return {
                ...state,
                WaitingSaveInstruction: true,
                SuccessSaveInstruction: false,
                statusSave: false,
                Errors: []
            }
        }
        case types.SAVE_INSTRUCTION_ERROR: {
            return {
                ...state,
                WaitingSaveInstruction: false,
                ErrorSaveInstruction: "error",
                statusSave: false,
                Errors: []
            }
        }
        case types.SAVE_INSTRUCTION_SUCCESS: {
            return {
                ...state,
                WaitingSaveInstruction: false,
                SuccessSaveInstruction: true,
                statusSave: action.data.Value,
                Errors: action.data.Errors

            }
        }
        case types.SAVE_INSTRUCTION_RESET_PROPS: {
            return {
                ...state,
                WaitingSaveInstruction: false,
                SuccessSaveInstruction: false,
                ErrorSaveInstruction: '',
                statusSave: false,
                Errors: []
            }
        }
        //***************************************************************************************************** */
        case types.GET_CUSTOM_MEMBER_REQUEST: {
            return {
                ...state,
                WaitingCustomMember: true,
                SuccessCustomMember: false,
            }
        }
        case types.GET_CUSTOM_MEMBER_ERROR: {
            return {
                ...state,
                WaitingCustomMember: false,
                ErrorCustomMember: "error",
            }
        }
        case types.GET_CUSTOM_MEMBER_SUCCESS: {
            return {
                ...state,
                WaitingCustomMember: false,
                SuccessCustomMember: true,
                CustomMember: action.data
            }
        }
        case types.GET_CUSTOM_MEMBER_RESET_PROPS: {
            return {
                ...state,
                WaitingCustomMember: false,
                SuccessCustomMember: false,
                ErrorCustomMember: '',
            }
        }

        default:
            return state
    }
}

export default secreteryReducer;